import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div
          className="relative overflow-hidden rounded-3xl p-14 text-center"
          style={{ background: 'var(--primary)' }}
        >
          {/* Background decoration */}
          <div className="absolute top-0 right-0 w-80 h-80 rounded-full bg-white/5 -translate-y-1/2 translate-x-1/4" />
          <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-white/5 translate-y-1/2 -translate-x-1/4" />

          {/* Background image */}
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://readdy.ai/api/search-image?query=aerial%20view%20of%20cargo%20airplanes%20and%20delivery%20trucks%20at%20a%20major%20international%20airport%20logistics%20hub%2C%20teal%20and%20green%20color%20tones%2C%20wide%20angle%20drone%20photography%2C%20professional%20commercial%20aviation%2C%20organized%20freight%20terminals%2C%20high%20altitude%20view&width=1280&height=400&seq=cta1&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-center"
            />
          </div>

          <div className="relative z-10">
            <h2 className="font-heading font-bold text-4xl md:text-5xl text-white mb-5">
              Ready to Ship with Confidence?
            </h2>
            <p className="text-white/80 text-lg max-w-xl mx-auto mb-10">
              Join over 50,000 businesses that rely on SwiftTrack every day for fast, transparent, and reliable deliveries worldwide.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/track"
                className="px-8 py-4 bg-white rounded-xl text-sm font-semibold transition-all hover:bg-white/90 whitespace-nowrap"
                style={{ color: 'var(--primary)' }}
              >
                Track a Shipment
              </Link>
              <Link
                to="/contact"
                className="px-8 py-4 rounded-xl text-sm font-semibold text-white border border-white/30 hover:border-white/60 transition-all whitespace-nowrap"
              >
                Get a Quote
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
